var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,146.83h56.11m24.94,0h12.47M143.4,152a12.13,12.13,0,1,1-12.12-12.13A12.12,12.12,0,0,1,143.4,152Zm37.41,0a12.13,12.13,0,1,1-12.12-12.13A12.12,12.12,0,0,1,180.81,152ZM63,152A12.13,12.13,0,1,1,50.91,139.9,12.13,12.13,0,0,1,63,152ZM153.1,49.85h15.24m-61,0h15.24m-27,12.88h83.83s12.46,26.33-.35,51.61H95.26S82.43,91.14,95.6,62.73ZM58.15,86.25l-18,22.21H65.12V86.29Zm122.66,60.58h12.08V127.17h-116V75.9H50.57L24.93,108.46v18.71H18.7v19.66H38.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTruck);
export default __webpack_public_path__ + "static/media/WATER_TRUCK.932b396ba1f24994f794f2c4b7b59c10.svg";
export { ForwardRef as ReactComponent };